import React from "react";
import { Card, Stack, Typography } from "@mui/material";
import FormFile from "../../../components/Forms/FormFile";
import FormTextTC from "../../../components/Forms/FormTextTC";
import ImageUuids from "../ImageUuids";
import FormJson from "../../../components/Forms/FormJson";

export default function MealConfigurator() {
  return (
    <Stack gap={3}>
      <Card sx={{ p: 1 }}>
        <Stack gap={2}>
          <Typography fontWeight={"bold"}>Starting image</Typography>
          <FormFile name={"meal_configurator_start"} nullable={true} type={"image"} />
        </Stack>
      </Card>
      <Card sx={{ p: 1 }}>
        <Stack alignItems={"flex-start"} gap={2}>
          <Typography fontWeight={"bold"}>Layer image</Typography>
          <FormFile name={"meal_configurator_layer"} nullable={true} type={"image"} />

          <FormTextTC
            name={"custom_data.meal_configurator.layer_index"}
            tDefault={"Layer index (High is on top, low is at bottom)"}
            tKey={"meal_configurator_layer.layer_index"}
          />
          <FormJson
            name={"meal_configurator_steps"}
            tDefault={"meal_configurator_steps"}
            tKey={"meal_configurator_steps"}
          />
          <Typography>Multiple images</Typography>
          <ImageUuids collectionName={"meal_configurator_layers"} columnName={"meal_configurator_layers"} />
        </Stack>
      </Card>
    </Stack>
  );
}
